module.exports = __webpack_public_path__ + "img/Animal-Prints_fr.bc66dcdb.jpg";